export const EDITOR_MAIN_SSR_CHUNK_NAME = 'editor_main_chunk';
export const RENDERED_SSR_CHUNKS_CUSTOM_DATA_KEY = 'rendered_ssr_chunks';
export const CONFLUENCE_SSR_CHUNKS_WINDOW_KEY = '__CONFLUENCE_SSR_CHUNKS__';

declare global {
	interface Window {
		__CONFLUENCE_SSR_CHUNKS__?: unknown;
	}
}

export const getRenderedSsrChunks = (): string[] => {
	if (typeof window === 'undefined') {
		return [];
	}

	const chunks = window[CONFLUENCE_SSR_CHUNKS_WINDOW_KEY];

	if (!Array.isArray(chunks)) {
		return [];
	}

	return [...new Set(chunks.filter((chunk): chunk is string => typeof chunk === 'string'))];
};
